
import { SET_SELECTED_CLANBATTLES_TAB, SET_SELECTED_TEAM_NUMBER, SET_CLAN_BATTLES_FETCHING, SET_CLAN_BATTLES, ON_CLICK_BATTLE } from "../Actions/ActionClanBattles";
import { Action } from "../../types/Action";

export const SEASON_TYPES = {
  REGULAR: 'regular',
  BRAWL: 'brawl'
};

export type State = {
  selectedTab: number;
  battlesList: Array<any>;
  isError: boolean;
  isFetching: boolean,
  selectedBattle: number;
  teamNumber: number;
};

let initialState: State = {
  selectedTab: 0,
  battlesList: [],
  isError: false,
  isFetching: false,
  selectedBattle: 0,
  teamNumber: 1
};

export type IReducerClanBattles = (state: State, action: Action) => State;
export const ReducerClanBattles = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case ON_CLICK_BATTLE:
      {
        const newSelectedBattle = action.payload.battleId === state.selectedBattle ? 0 : action.payload.battleId;
        return {
          ...state,
          selectedBattle: newSelectedBattle
        };
      }
    case SET_CLAN_BATTLES:
      {
        return {
          ...state,
          battlesList: action.payload.battles
        };
      }
    case SET_CLAN_BATTLES_FETCHING:
      {
        return {
          ...state,
          isFetching: action.payload.isFetching,
        };
      }
    case SET_SELECTED_TEAM_NUMBER:
      {
        return {
          ...state,
          teamNumber: action.payload.teamNumber
        };
      }
    case SET_SELECTED_CLANBATTLES_TAB:
      {
        return {
          ...state,
          selectedTab: action.payload.selectedTab
        };
      }

    default:
      return state;

  }
};